import axios from 'axios'

// 获取青豆工单列表
export function queryChindleUserPage (datas) {
  const url = `/customerChindleUser/queryChindleUserPage`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 青豆工单导出
export function exportChindleUserInfo (datas) {
  const url = `/customerChindleUser/exportChindleUserInfo`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 新增青豆工单
export function addChindleUserInfo (datas) {
  const url = `/customerChindleUser/addChindleUserInfo`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 编辑青豆工单
export function editChindleUserInfo (datas) {
  const url = `/customerChindleUser/editChindleUserInfo`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 青豆用户信息指派
export function assignChindleUserInfo (datas) {
  const url = `/customerChindleUser/assignChindleUserInfo`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 青豆用户信息编辑回显
export function editChindleUserReturn (datas) {
  const url = `/customerChindleUser/editChindleUserReturn`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 青豆用户信息获取有权限的客服列表
export function queryPermissionCustomerList (datas) {
  const url = `/customerChindleUser/queryPermissionCustomerList`
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/order/chindle.js